import {
  Box,
  Grid,
  Hidden,
  InfoOutlinedIcon,
  PlayCircleOutlinedIcon,
  PlayRectangleWithoutGradientIcon,
  useMediaQuery,
  useTheme,
  WhiteTooltip
} from '@hermes/web-components'
import { SponsoredBanner, StyledAvatar } from './styles'
import { TEST_IDS } from '../../../../../../__tests__/testUtils/constants'
import { StyledPlayVideoButton } from '../../../../../profiles/Intro/styles'
import useTranslateMessage from '../../../../../../hooks/useTranslateMessage'
import { SharedLinkData } from '../../../../../../types'
import React from 'react'

type ProfileAvatarProps = {
  isSponsor: boolean
  profileFullName: string
  profileAvatarLink: string
  profileAbbreviation: string
  introductionVideoAvailable: boolean
  introductionVideo?: SharedLinkData
  handleOpenIntroductionVideoPlayer: () => void
}

const ProfileAvatar = ({
  isSponsor,
  profileFullName,
  profileAvatarLink,
  profileAbbreviation,
  introductionVideoAvailable,
  introductionVideo,
  handleOpenIntroductionVideoPlayer
}: ProfileAvatarProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const translate = useTranslateMessage()

  return (
    <Box height="min-content" position="relative">
      {isSponsor && (
        <WhiteTooltip
          placement={isMobile ? 'bottom-end' : 'right'}
          title={translate('search-profile.sponsored.tooltip')}
          sx={{
            '& .MuiTooltip-tooltip': {
              padding: '12px 16px',
              maxWidth: '354px',
              width: '100%',
              height: 'auto',
              fontSize: '11px',
              lineHeight: '14px'
            }
          }}
        >
          <SponsoredBanner>
            {translate('search-profile.sponsored')} <InfoOutlinedIcon sx={{ fontSize: 14, color: '#112971' }} />
          </SponsoredBanner>
        </WhiteTooltip>
      )}
      <StyledAvatar
        alt={profileFullName}
        data-testid={TEST_IDS.SEARCH_RESULT_CARD_AVATAR}
        width={80}
        height={80}
        preload
        src={profileAvatarLink}
      >
        {profileAbbreviation}
      </StyledAvatar>
      {introductionVideoAvailable && !!introductionVideo?.link.length ? (
        <StyledPlayVideoButton
          data-testid={TEST_IDS.SEARCH_RESULT_CARD_VIDEO_BUTTON}
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation()
            handleOpenIntroductionVideoPlayer()
          }}
        >
          <Grid container component={Hidden} lgUp implementation="css">
            <PlayRectangleWithoutGradientIcon sx={{ width: '48px', height: '24px' }} />
          </Grid>
          <Grid container component={Hidden} lgDown implementation="css">
            <PlayCircleOutlinedIcon sx={{ width: '32px', height: '32px' }} />
          </Grid>
        </StyledPlayVideoButton>
      ) : null}
    </Box>
  )
}

export default ProfileAvatar
